<template>
    <PromoLayout>
        <div class="quote">
            <div
                class="quote__fixed-photo"
                :style="{
                    backgroundImage: 'url(/images/promo/bg.jpg)',
                }"
            >
                <quoteTable />
            </div>
            <div
                class="quote__fixed-photo mobile"
                :style="{
                    backgroundImage: 'url(/images/promo/mobile-bg.jpg)',
                }"
            ></div>
            <template v-if="formSent">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <thankYou />
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <quoteForm ref="quoteFormMobile" @formSent="showThankYou" />
                <div class="container d-block d-lg-none">
                    <div class="row">
                        <div class="col-12">
                            <quoteTable />
                            <button
                                class="btn btn-primary d-flex justify-content-center align-items-center d-lg-none w-100 quote__popup-toggle"
                                @click="openFormPopup"
                            >
                                {{ $t("promo.Send me my quote") }}
                                <img
                                    src="/images/promo/arrow-right.svg"
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>
                </div>

                <quoteOptions @update="updatePrice" />
            </template>
        </div>
    </PromoLayout>
</template>

<script>
import PromoLayout from "@/Layouts/Promo";
import QuoteForm from "@/Components/Promo/QuoteForm";
import QuoteTable from "@/Components/Promo/QuoteTable";
import QuoteOptions from "@/Components/Promo/QuoteOptions";
import ThankYou from "@/Components/Promo/ThankYou";
import { mapGetters } from "vuex";

export default {
    components: {
        PromoLayout,
        QuoteForm,
        QuoteTable,
        QuoteOptions,
        ThankYou,
    },
    data() {
        return {
            base_price: 0,
            final_price: 0,
            formSent: false,
            roof_multipliers: {
                tiles: 1,
                metal: 1, //0.9,
                stone: 1, //1.1,
                flat: 1, //1.05,
                ground: 1, //1.1
            },
        };
    },
    methods: {
        showThankYou() {
            this.formSent = true;
        },
        openFormPopup() {
            this.$refs.quoteFormMobile.openModal = true;
        },
        updatePrice(val) {
            console.table(val);
            var toAdd = 0;
            if (val.panel_type === "glass-glass") {
                toAdd += this.options.vision_surcharge;
            }
            if (val.full_black) {
                toAdd += this.options.full_black_surcharge;
            }
            if (val.power_optimizers) {
                toAdd += this.options.optimizers_surcharge;
            }
            if (val.microinverters) {
                toAdd += this.options.microinverters_surcharge;
            }
            this.final_price = this.base_price + toAdd;

            // if (val.financing == "monthly") {
            // this.final_price = this.final_price * 1.08;
            // }
            this.$store.dispatch("setPrice", this.final_price);
        },
        calcBasePrice() {
            let moduleMultiplier;
            if (this.locale === "nl") {
                // moduleMultiplier = (this.options.panel_type === 'glass-glass') ? 1.6 : 1.3;
                moduleMultiplier = 1.3;
            } else {
                moduleMultiplier = this.getPolishBasePrice();
            }
            var roof_multiplier =
                this.roof_multipliers[this.roof.toLowerCase()];
            var base_price =
                Number(this.installation_size * 1000) *
                Number(moduleMultiplier) *
                roof_multiplier;
            this.base_price = base_price;
            this.$store.dispatch("setBasePrice", base_price);
        },
        getPolishBasePrice() {
            if (this.installation_size < 4) {
                return 6;
            }
            if (this.installation_size < 5) {
                return 5.7;
            }
            if (this.installation_size < 6) {
                return 5.15;
            }
            if (this.installation_size < 7) {
                return 5;
            }
            if (this.installation_size < 8) {
                return 4.9;
            }

            if (this.installation_size > 20) {
                return 4;
            }
            return 4.8;
        },
    },
    computed: {
        locale() {
            return process.env.MIX_APP_LOCALE || "pl";
        },
        ...mapGetters({
            monthly_payment: "monthly_payment",
            roof: "roof_type",
            annual_consumption: "annual_consumption",
            options: "options",
            installation_size: "installation_size",
        }),
    },
    mounted() {
        if (!this.monthly_payment || !this.roof) {
            this.$inertia.get(this.route("promo"));
        } else {
            this.calcBasePrice();
        }
    },
};
</script>
<style lang="scss" scoped>
.quote {
    position: relative;
    padding-bottom: 60px;
    &__popup-toggle {
        background: #1eb26d;
        border-radius: 50px;
        height: 56px;
        display: block;
        width: 100%;
        border: none;
        outline: none !important;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        margin-bottom: 8px;
        box-shadow: none !important;
        img {
            margin-left: 5px;
        }
        &:hover,
        &:active {
            background: darken(#1eb26d, 5%) !important;
        }
    }
    &__fixed-photo {
        background: #f7f9fc;
        position: fixed;
        right: 0;
        top: 0;
        width: calc(50% - 80px);
        height: 100vh;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: center;
        padding-top: 32px;
        padding-bottom: 32px;
        box-sizing: border-box;
        align-items: baseline;
        overflow-y: scroll;
        z-index: 100;
        &.mobile {
            display: none;
        }
        @media (max-width: 991px) {
            &.mobile {
                display: block;
            }
            &:not(.mobile) {
                display: none;
            }
            position: relative;
            height: 40vw;
            width: 100%;
        }
    }
}
</style>
